module.exports = __webpack_public_path__ + "img/see-todos-button.77704bd8.png";